<template>
  <div class="public-product-list">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-title">{{ $t('PublicProductList.line5_text') }}</div>
      <button class="btn-login" @click="$router.push('/login')">{{ $t('common.login') }}</button>
    </header>

    <!-- 内容 -->
    <div class="content" @scroll="handleScroll">
      <!-- 商品列表 -->
      <div v-if="products.length > 0" class="product-grid">
        <div 
          v-for="product in products" 
          :key="product.id" 
          class="product-card"
          @click="viewDetail(product.id)"
        >
          <div class="product-image">
            <img 
              v-if="product.mainImage" 
              :src="getImageUrl(product.mainImage)" 
              :alt="product.name"
            />
            <div v-else class="no-image">📦</div>
          </div>
          
          <div class="product-info">
            <div class="product-name">{{ product.name }}</div>
            <div class="product-meta">{{ product.categoryName || '未分类' }}</div>
            <div class="product-price">
              <span class="price-label">{{ $t('PublicProductList.line32_text') }}</span>
              <span class="price-value">¥{{ product.marketPrice || '0.00' }}</span>
            </div>
            <div class="product-unit">{{ product.unit || '千克' }}</div>
          </div>
        </div>
      </div>
      
      <!-- 空状态 -->
      <div v-else-if="!loading" class="empty-state">
        <div class="empty-icon">📦</div>
        <p>{{ $t('common.noProduct') }}</p>
      </div>
      
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-state">
        <div class="loading-spinner">⏳</div>
        <p>{{ $t('common.loading') }}</p>
      </div>
      
      <!-- 没有更多数据 -->
      <div v-if="noMore && products.length > 0" class="no-more-state">
        <p>{{ $t('PublicProductList.line54_text') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { getImageUrl } from '@/utils/image';

export default {
  name: 'PublicProductList',
  data() {
    return {
      products: [],
      loading: false,
      page: 0,
      pageSize: 20,
      noMore: false
    };
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    getImageUrl,
    async loadProducts() {
      if (this.loading || this.noMore) return;
      
      this.loading = true;
      try {
        // 获取公开的商品列表（只显示市场价）- 分页加载
        const response = await api.get('/product/public/list', {
          params: {
            page: this.page,
            size: this.pageSize
          }
        });
        
        const newData = response.content || response || [];
        
        if (newData.length < this.pageSize) {
          this.noMore = true;
        }
        
        // 追加数据
        this.products = [...this.products, ...newData];
        this.page++;
      } catch (error) {
        console.error('加载商品失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    handleScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      // 距离底部 100px 时触发加载
      if (scrollHeight - scrollTop - clientHeight < 100) {
        this.loadProducts();
      }
    },
    
    viewDetail(productId) {
      this.$router.push(`/product/${productId}`);
    }
  }
};
</script>

<style scoped>
.public-product-list {
  min-height: 100vh;
  background: #f5f5f5;
}

.header {
  background: white;
  border-bottom: 1px solid #eee;
  padding: calc(16px + env(safe-area-inset-top, 0px));
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-title {
  flex: 1;
  text-align: center;
  font-weight: bold;
  color: #333;
  font-size: 16px;
}

.btn-login {
  padding: 8px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.content {
  padding: 16px;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.product-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  cursor: pointer;
  transition: transform 0.2s;
}

.product-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.product-image {
  width: 100%;
  height: 150px;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-image {
  font-size: 48px;
  color: #ddd;
}

.product-info {
  padding: 12px;
}

.product-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-meta {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}

.product-price {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 4px;
}

.price-label {
  font-size: 12px;
  color: #999;
}

.price-value {
  font-size: 18px;
  font-weight: 700;
  color: #ff4d4f;
}

.product-unit {
  font-size: 12px;
  color: #666;
}

.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #999;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
}
</style>
